import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {TestimonialsComponent} from '../testimonials/testimonials.component';
import {TransactionsComponent} from './transactions.component';

const routes: Routes = [
  {
    path: 'transactions',
    component: TransactionsComponent,
    data: {animation: 'transactions'}
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransactionsRoutingModule { }
